import React from 'react';

import OfferCardView from './view';

function OfferCard(props) {
	return <OfferCardView props={props} />;
}

export default OfferCard;
